import { useWindowDimensions } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { pageLayout, type PageLayoutOptions } from '../lib/pageLayout'

/** Page grids live inside a SafeAreaView, whose side padding consumes width. */
export function usePageLayout(options: PageLayoutOptions = {}) {
  const { width } = useWindowDimensions()
  const { left, right } = useSafeAreaInsets()
  return pageLayout(Math.max(0, width - left - right), options)
}
